import React from "react";
import PropTypes from "prop-types";
import { TvDiv, TvP } from "@trustvid/design-system";
import { LOGIN_PAGE_HERO } from "./loginPageContent";

const LoginFeatureHero = ({ pageHeading, compact = false }) => {
  const headline = pageHeading ?? LOGIN_PAGE_HERO.headline;

  return (
    <TvDiv className={`tv-login-page__hero${compact ? " tv-login-page__hero--compact" : ""}`}>
      <TvDiv
        className="tv-login-page__hero-headline"
        data-testid={compact ? "login-compact-heading" : "login-page-heading"}
      >
        {compact ? (
          headline.replace(/\n/g, " ")
        ) : (
          headline.split("\n").map((line, i, arr) => (
            <React.Fragment key={i}>
              {line}
              {i < arr.length - 1 && <br />}
            </React.Fragment>
          ))
        )}
      </TvDiv>
      {!compact ? (
        <TvP className="tv-login-page__hero-subline mb-0">{LOGIN_PAGE_HERO.subline}</TvP>
      ) : null}
    </TvDiv>
  );
};

LoginFeatureHero.propTypes = {
  pageHeading: PropTypes.string,
  compact: PropTypes.bool,
};

export default LoginFeatureHero;
